// handlers/pdf_handler.js
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import QRCode from 'qrcode'; // npm install qrcode'

import PretripInspectionReport from './PretripInspectionReport';

export const exportToPDF = async (elementId, filename = 'document.pdf') => {
  try {
    const element = document.getElementById(elementId);
    if (!element) {
      console.error(`Element with ID '${elementId}' not found.`);
      return;
    }

    // Get real size from DOM
    const rect = element.getBoundingClientRect();
    const contentWidth = rect.width; // in px
    const contentHeight = rect.height; // in px

    // 1 px ≈ 0.264583 mm
    const mm = 0.264583;
    const pdfWidth = Math.ceil(contentWidth * mm); 
    const pdfHeight = Math.ceil(contentHeight * mm);

    // Render ke canvas tanpa skala (gunakan ukuran aslinya)
    const canvas = await html2canvas(element, {
      useCORS: true,
      backgroundColor: null,
      scale: 1, 
    });

    const imgData = canvas.toDataURL('image/png');

    const pdf = new jsPDF('p', 'mm', [pdfWidth, pdfHeight]); // <-- custom size

    pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);

    pdf.save(filename);
  } catch (err) {
    console.error('Failed in generating PDF:', err);
  }
};

// handlers/image_handler.js
export const exportToJPG = async (elementId, filename = 'image.jpg', quality = 0.8) => {
  try {
    const element = document.getElementById(elementId);
    if (!element) {
      console.error(`Element with ID '${elementId}' not found.`);
      return;
    }

    const canvas = await html2canvas(element, {
      useCORS: true,
      backgroundColor: 'white',
    });

    const imgData = canvas.toDataURL('image/jpeg', quality); // quality: 0.1 (low) - 1.0 (high)

    // Buat link unduhan
    const link = document.createElement('a');
    link.href = imgData;
    link.download = filename;
    link.click();
  } catch (err) {
    console.error('Failed in generating JPG:', err);
  }
};

export const exportHiddenQR = async (text, options = {}) => {
  const {
    filename = text,
    quality = 1.0,
    size = 250,
    scale = 3
  } = options;

  try {
    // Buat container sementara
    const container = document.createElement('div');
    container.style.position = 'absolute';
    container.style.left = '-9999px';
    container.style.top = '-9999px';
    container.style.width = '400px';
    container.style.padding = '2em 0';
    container.style.backgroundColor = 'white';
    container.style.textAlign = 'center';
    container.style.fontFamily = 'Arial, sans-serif';

    // Buat element QR dengan canvas
    const canvas = document.createElement('canvas');
    await QRCode.toCanvas(canvas, text, {
      width: size,
      margin: 2,
      color: {
        dark: '#000000',
        light: '#ffffff'
      }
    });
    
    canvas.style.margin = '0 auto';
    canvas.style.display = 'block';

    // Buat title dan text
    const title = document.createElement('h2');
    title.textContent = 'Scan to start checklist';
    title.style.margin = '0 0 1em 0';
    title.style.color = '#333';

    const footer = document.createElement('h4');
    footer.textContent = text;
    footer.style.margin = '1em 0 0 0';
    footer.style.color = '#666';
    footer.style.fontSize = '14px';
    footer.style.wordBreak = 'break-all';
    footer.style.padding = '0 20px';

    // Susun semua element
    container.appendChild(title);
    container.appendChild(canvas);
    container.appendChild(footer);
    
    // Tambah ke body (sementara)
    document.body.appendChild(container);

    // Tunggu bentar biar rendering selesai
    await new Promise(resolve => setTimeout(resolve, 100));

    // Export ke JPG
    const resultCanvas = await html2canvas(container, {
      scale: scale,
      backgroundColor: '#ffffff',
      allowTaint: false,
      useCORS: true,
      logging: false
    });

    // Download
    const imageData = resultCanvas.toDataURL('image/jpeg', quality);
    const link = document.createElement('a');
    link.download = `${filename}-${Date.now()}.jpg`;
    link.href = imageData;
    link.click();

    // Bersihin container
    document.body.removeChild(container);

    return true;
  } catch (error) {
    console.error('Export failed:', error);
    return false;
  }
};

export {
    PretripInspectionReport
}